;(function($) {
  "use strict"
  $(function() {
    $(document).click(function(e) {
      var $currItem = $(e.target).closest(".field__top")
      const $currField = $currItem.closest(".field")
      if ($currItem.length !== 0) {

          $currField.toggleClass("js-is-opened")
        
      }
    })
    $(document).click(function(e) {
      var $currItem = $(e.target).closest(".pair_copy")
      if ($currItem.length !== 0) {
        e.preventDefault()
        var copyTextarea = $(".pair__copy-val")
        copyTextarea.val($(location).attr("href"))
        copyTextarea.focus()
        copyTextarea.select()
        document.execCommand("copy")

        $currItem.toggleClass("js-opened")

        setTimeout(function() {
          $currItem.removeClass("js-opened")
        }, 2000)
      }
    })

    $(document).click(function(e) {
      var $currItem = $(e.target).closest(".pair__dropper")
      if ($currItem.length !== 0) {
        $currItem.closest(".pair").toggleClass("js-drop")
      }
    })

    $(document).click(function(e) {
      var $currItem = $(e.target).closest(".pair__close")
      if ($currItem.length !== 0) {
        $currItem.closest(".pair").removeClass("js-drop")
      }
    })
  })
})(jQuery)
